module.exports = __webpack_public_path__ + "img/lv17.b2a8e2b7.png";